module.exports = __webpack_public_path__ + "img/大通_LOGO_320x150.6cceaed7.png";